import { SetFiltersRequest } from '../../../../../../grid/types/common';

export function convertRegexFilterToStartsWithFilter(request: SetFiltersRequest<string>, columnKey: string): any {
  const nameFilterIdx = request.filters.findIndex(filter => Object.keys(filter)[0] === columnKey);
  if (nameFilterIdx !== -1 && request.filters[nameFilterIdx][columnKey].regex) {
    request.filters[nameFilterIdx][columnKey].startsWith = request.filters[nameFilterIdx][columnKey].regex.pattern;
    delete request.filters[nameFilterIdx][columnKey].regex;
  }
}

export function convertRegexFilterToBooleanFilter(request: SetFiltersRequest<string>, columnKey: string): any {
  const statusFilterIdx = request.filters.findIndex(filter => Object.keys(filter)[0] === columnKey);
  if (statusFilterIdx !== -1) {
    request.filters[statusFilterIdx][columnKey].in = request.filters[statusFilterIdx][columnKey].in.map(
      status => !!status
    );
  }
}
